var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{tag:"component",class:[
    'reactivate-button',
    {'text-oth-6 bg-oth-7' : !_vm.colored},
    {'text-gray-4 bg-prim-1' : _vm.colored},
    {'reactivate-button_s': _vm.size === 's'},
    {'reactivate-button_m': _vm.size === 'm'},
    {'reactivate-button_l': _vm.size === 'l'}
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }